<template>
    <ul class="sidebarMain">
        <li>
            <div class="profile">{{getInitial}}</div>
            <p class="fullname">{{getFullName}}</p>
        </li>
        <li>
            <div class="col-12" v-if="codePtf && codePtf.length > 0">
                <p><b>Code portefeuille :</b></p>
                <div class="select__wrapper">
                    <font-awesome-icon :icon="['far', 'chevron-down']" />
                    <b-form-select v-model="selected" :options="codePtf" class="select">
                    </b-form-select>
                </div>
            </div>
        </li>

        <div class="sep"></div>

        <li v-for="menu in menus" :key="menu.text">
            <b-button class="bt bt-icon"  :to="menu.link">
              <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
              </span>
                <p> {{menu.text}}</p>
            </b-button>
        </li>

        <div class="sep"></div>
    </ul>
</template>

<script>
    import { mapGetters } from 'vuex'
    import {ApplicationsAccessEnum} from "@/services/Enum/ApplicationsAccessEnum";
    import ApiAuthenticationService from "@/services/ApiAuthenticationService";

    const menuResume = {
      link:'/resume/',
      text:'Résumé',
      iconType:'fas',
      iconName:'file'
    };
    const menuParcourir = {
      link:'/parcourir/',
      text:'Parcourir',
      iconType:'far',
      iconName:'telescope'
    };
    const menuPro = {
      link:'/pro/',
      text:'PRO',
      iconType:'far',
      iconName:'bullseye-arrow'
    };
    const menuCommerciaux = {
      link:'/commerciaux/',
      text:'Commerciaux',
      iconType:'far',
      iconName:'users'
    };
    const menuConcours = {
      link:'/challenges/',
      text:'Challenges',
      iconType:'far',
      iconName:'trophy-alt'
    };
    const menuExport = {
      link: '/exports/',
      text: 'Export',
      iconType: 'far',
      iconName: 'file-export'
    };

    export default {
        name: "SidebarMain",
        components: {
        },
        data() {
            return {
                menus: [],
                codePtf:[],
                selected: null,
            }
        },
        computed: {
            ...mapGetters([
                'getInitial',
                'getFullName',
                'getCodePtf'
            ])
        },
        created (){
          let currentUserApplicationsAccess = ApiAuthenticationService.getCurrentUser().applicationsAccess;
          if (typeof currentUserApplicationsAccess === 'object') {
            currentUserApplicationsAccess = Object.values(currentUserApplicationsAccess);
          }
          if (currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_RESUME)) {
            this.menus.push(menuResume)
          }
          if (currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_CONCOURS)) {
            this.menus.push(menuConcours)
          }
          if (currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_PARCOURIR_NATIONAL) || currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_PARCOURIR)) {
            this.menus.push(menuParcourir)
          }
          if (currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_EXPORT) || currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_ADMIN_EXPORT)) {
            this.menus.push(menuExport)
          }
          if (currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_COMMERCIALS)) {
            this.menus.push(menuCommerciaux)
          }
          if (currentUserApplicationsAccess.includes(ApplicationsAccessEnum.APP_PRO_PERSONAL)) {
            this.menus.push(menuPro)
          }

          this.selectDefaultCodePtf();
        },
        activated (){
            this.selectDefaultCodePtf();
        },
        methods: {
          selectDefaultCodePtf() {
            if(this.getCodePtf?.length > 0){
              this.selected = this.codePtf[0];
              this.$store.dispatch('setCurrentCodePtf',this.selected);
            } else {
              this.$store.dispatch('setCurrentCodePtf',null);
            }
          }
        },
        watch: {
            'selected' : function() {
                this.$store.dispatch('setCurrentCodePtf',this.selected);
            },
        }
    }
</script>
